import React, { Component } from "react";
import { Progress } from "reactstrap";
import "./DivCarousel.css";
import Card from "../Card/Card";
// import Carousel from "../Carousel/Carousel";

export default class DiveCarousel extends Component {
  renderCard() {
    if (Object.keys(this.props.listjson).length > 0) {
      // var json = JSON.parse(this.props.listjson);
      var json = this.props.listjson;
      return Object.keys(json).map((value, index) => (
        // console.log(json[value])
        <Card
          key={value}
          title={json[value].name}
          content={json[value].description}
          width="400px"
          margin="20px"
          src={json[value].url}
        />
      ));
    } else {
      var style = {
        width: "400px",
        display: "inline-block",
        padding: "100px 30px"
      };
      return (
        <div>
          <div style={style}>
            <Progress animated color="info" value="100" />
          </div>
          <div style={style}>
            <Progress animated color="info" value="100" />
          </div>
        </div>
      );
    }
  }
  render() {
    console.log(this.props);
    return (
      <div>
        {/* <Carousel /> */}
        <div className="width-divcarousel">
          <img
            src={this.props.details.avatar}
            alt={"avatar:" + this.props.name}
            className="avatarimg"
          />
          <div className="contentname" style={{}}>
            <div className="h1left">{this.props.name}</div>
            <br />
            <div className="h3left-tab">{this.props.details.description} </div>
          </div>
        </div>

        {/* <h1 className="h1left"> {this.props.name} </h1>
          <h3 className="h3left-tab">
            {" "}
            About : {this.props.details.description}
          </h3> */}
        {/* <h3 className="h3left-tab"> {this.props.listjson.description} </h3> */}
        {this.renderCard()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DivCarousel/DivCarousel.js